import { all, call, put, select, takeLatest } from 'redux-saga/effects'
import agent from 'agent'

import { formatSerpHistoryData } from 'helpers/formatSerpHistoryData'
import appMode from 'helpers/getAppMode'
import { exportSaga } from './export.sagas'

import * as actions from 'redux/actions/keywords.actions'
import * as domainsDataActions from 'redux/actions/domainsData.actions'
import * as accountActions from 'redux/actions/account.actions'
import { loadDomainOverview } from 'redux/actions/domainsList.actions'
import NotificationToast from '_base/Notification'

function* getKeywordSerp(params) {
  try {
    const { domainId, keywordId } = params.payload
    const request = appMode.share ? agent.Share.serp : agent.Keywords.serp
    const body = yield call(request, domainId, keywordId)
    yield put(actions.getKeywordSerpSuccess(domainId, keywordId, body.data.attributes))
  } catch (error) {
    yield put(actions.getKeywordSerpFailure(error))
  }
}

function* addKeyword(params) {
  try {
    const { domainId, payload } = params.payload
    yield call(agent.Keywords.add, domainId, payload)
    yield put(actions.addKeywordSuccess(domainId))
    NotificationToast('success', `"${payload.keywords.words[0]}" successfully added.`)
  } catch (error) {
    NotificationToast('error', 'The keyword could not be added.')
    yield put(actions.addKeywordFailure(error))
  }
}

function* getKeywordHistory(params) {
  try {
    const { domainId, keywordId } = params.payload
    const state = yield select()
    const request = appMode.share ? agent.Share.history : agent.Keywords.history
    const body = yield call(request, domainId, keywordId, state.filters)
    const data = body.data.map(item => ({
      date: item.attributes.date,
      position: item.attributes.position
    }))

    yield put(actions.getKeywordHistorySuccess(domainId, keywordId, { chart: data }))
  } catch (error) {
    yield put(actions.getKeywordHistoryFailure(error))
  }
}

function* getSerpHistory(params) {
  try {
    const { domainId, keywordId } = params.payload
    const state = yield select()
    const request = appMode.share ? agent.Share.serpHistory : agent.Keywords.serpHistory
    const body = yield call(request, domainId, keywordId, state.filters)
    const data = formatSerpHistoryData(body.data)

    yield put(actions.getSerpHistorySuccess(data))
  } catch (error) {
    yield put(actions.getSerpHistoryFailure(error))
  }
}

function* updateKeywords(params) {
  try {
    const { domainId, payload } = params.payload
    yield call(agent.Keywords.update, domainId, payload)
    yield put(domainsDataActions.loadKeywords(domainId))

    yield put(actions.updateKeywordsSuccess())

    yield put(accountActions.getAccountData())
  } catch (error) {
    yield put(actions.updateKeywordsFailure(error))
  }
}

function* deleteKeywords(params) {
  try {
    const { domainId, payload } = params.payload
    const state = yield select()
    yield call(agent.Keywords.del, domainId, payload)
    yield put(domainsDataActions.loadKeywords(domainId, state.filters))

    yield put(actions.deleteKeywordsSuccess())

    yield put(accountActions.getAccountData())

    yield put(loadDomainOverview(domainId))
  } catch (error) {
    yield put(actions.deleteKeywordsFailure(error))
  }
}

function* exportKeywordsExcelSaga(params) {
  yield call(exportSaga, {
    params: params.payload,
    type: 'xls',
    request: agent.Keywords.exportKeywordsExcel,
    requestShared: agent.Share.exportShareKeywordsExcel
  })
}

function* exportKeywordsCSVSaga(params) {
  yield call(exportSaga, {
    params: params.payload,
    type: 'csv',
    request: agent.Keywords.exportKeywordsCSV,
    requestShared: agent.Share.exportShareKeywordsCSV
  })
}

export default function* keywordsSagas() {
  yield all([
    takeLatest(actions.getKeywordSerp.type, getKeywordSerp),
    takeLatest(actions.getKeywordHistory.type, getKeywordHistory),
    takeLatest(actions.getSerpHistory.type, getSerpHistory),
    takeLatest(actions.updateKeywords.type, updateKeywords),
    takeLatest(actions.deleteKeywords.type, deleteKeywords),
    takeLatest(actions.exportDomainKeywordsExcel.type, exportKeywordsExcelSaga),
    takeLatest(actions.exportDomainKeywordsCSV.type, exportKeywordsCSVSaga),
    takeLatest(actions.addKeyword.type, addKeyword)
  ])
}
